// eslint-disable-next-line import/no-anonymous-default-export
export default {
  formId: "PostDocForm",
  formField: {
    //Page 1
    photo: {
      name: "photo",
      label: "Choose your Photo",
      requiredErrorMsg: "Photo is required",
      file: {}
    },
    email: {
      name: "email",
      label: "Email*",
      requiredErrorMsg: "Email is required",
      invalidErrorMsg: "Email is not valid (e.g. Test@gmail.com)"
    },
    password: {
      name: "password",
      label: "Password*",
      requiredErrorMsg: "Password is required"
    },
    titleNameEng: {
      name: "titleNameEng",
      label: "Title's name",
      requiredErrorMsg: "Title name is required"
    },
    firstNameEng: {
      name: "firstNameEng",
      label: "Name (In English)",
      requiredErrorMsg: "First name is required"
    },
    middleNameEng: {
      name: "middleNameEng",
      label: "Middle Name (In English)"
    },
    lastNameEng: {
      name: "lastNameEng",
      label: "Surname (In English)",
      requiredErrorMsg: "Last name is required"
    },
    titleNameThai: {
      name: "titleNameThai",
      label: "Title's name (In Thai)",
      requiredErrorMsg: "Title name is required"
    },
    firstNameThai: {
      name: "firstNameThai",
      label: "Name (In Thai)",
      requiredErrorMsg: "First name is required"
    },
    middleNameThai: {
      name: "middleNameThai",
      label: "Middle Name (In Thai)"
    },
    lastNameThai: {
      name: "lastNameThai",
      label: "Surname (In Thai)",
      requiredErrorMsg: "Last name is required"
    },

    gender: {
      name: "gender",
      label: "Gender",
      requiredErrorMsg: "Gender is required"
    },
    dateOfBirth: {
      name: "dateOfBirth",
      label: "Date of Birth*",
      requiredErrorMsg: "Date of Birth is required",
      invalidErrorMsg: '"Date of Birth is not valid'
    },
    maritalStatus: {
      name: "maritalStatus",
      label: "Marital status",
      requiredErrorMsg: "Marital status is required"
    },
    bloodType: {
      name: "bloodType",
      label: "Blood type",
      requiredErrorMsg: "Blood Type is required"
    },
    idCard: {
      name: "idCard",
      label: "ID card (Thai citizen) / Passport No.",
      requiredErrorMsg: "ID card is required"
    },
    nationality: {
      name: "nationality",
      label: "Nationality",
      requiredErrorMsg: "Nationality is required"
    },
    yearOfTheContract: {
      name: "yearOfTheContract",
      label: "Year of the Contract",
      requiredErrorMsg: "Year of the Contract is required"
    },

    /////////////////////////////////////////////////////////////////////////////
    //Page 2

    faculty: {
      name: "faculty",
      label: "Faculty / College / Institute",
      requiredErrorMsg: "Faculty / College / Institute is required"
    },
    department: {
      name: "department",
      label: "Department",
      requiredErrorMsg: "Department is required"
    },
    mobileThai: {
      name: "mobileThai",
      label: "Mobile Number During Staying in Thai",
      requiredErrorMsg: "Mobile Number is required"
    },
    mobileCountry: {
      name: "mobileCountry",
      label: "Mobile Number at the Country of Residence",
      requiredErrorMsg: "Mobile Number is required"
    },
    // email2: {
    //   name: "email",
    //   label: "Email*",
    //   requiredErrorMsg: "Email is required",
    //   invalidErrorMsg: "Email is not valid (e.g. Test@gmail.com)"
    // },
    studentId: {
      name: "studentId",
      label: "Student ID",
      requiredErrorMsg: "Student ID is required"
    },
    mentor_id: {
      name: "mentor_id"
    },
    mentorName: {
      name: "mentorName",
      label: "Mentor's name",
      requiredErrorMsg: "Mentor's name is required"
    },
    mentorEmail: {
      name: "mentorEmail",
      label: "Mentor's email",
      requiredErrorMsg: "Mentor's email is required"
    },
    startFellowship: {
      name: "startFellowship",
      label: "Start Receiving Fellowship on",
      requiredErrorMsg: "Start Receiving Fellowship is required"
    },
    contractEnd: {
      name: "contractEnd",
      label: "Contract Ending on",
      requiredErrorMsg: "Contract Ending is required"
    },
    fieldResearch: {
      name: "fieldResearch",
      label: "Field of Research",
      requiredErrorMsg: "Field of Research is required"
    },
    addressInThailand: {
      name: "addressInThailand",
      label: "Address in Thailand",
      requiredErrorMsg: "Address in Thailand is required"
    },
    addressInTheCountryOfResidence: {
      name: "addressInTheCountryOfResidence",
      label: "Address in the Country of Residence ",
      requiredErrorMsg: "Address in the Country is required"
    },

    /////////////////////////////////////////////////////////////////////////////
    //Page 3
    nameOfTheBachelorDegree: {
      name: "nameOfTheBachelorDegree",
      label: "Name of the Bachelor’s Degree ",
      requiredErrorMsg: "Name of the Bachelor Degree is required"
    },
    graduatedUniversityInstituteBachelorDegree: {
      name: "graduatedUniversityInstituteBachelorDegree",
      label: "Graduated from University/Institute",
      requiredErrorMsg: "Graduated is required"
    },
    countryBachelorDegree: {
      name: "countryBachelorDegree",
      label: "Country",
      requiredErrorMsg: "Country is required"
    },
    dateOfBachelorDegreeGraduation: {
      name: "dateOfBachelorDegreeGraduation",
      label: "Date of Bachelor’s Degree Graduation ",
      requiredErrorMsg: "Date is required"
    },

    nameOfMasterDegree: {
      name: "nameOfMasterDegree",
      label: "Name of Master’s Degree",
      requiredErrorMsg: "Name of Master Degree is required"
    },
    graduatedUniversityInstituteMasterDegree: {
      name: "graduatedUniversityInstituteMasterDegree",
      label: "Graduated from University/Institute",
      requiredErrorMsg: "Graduated is required"
    },
    countryMasterDegree: {
      name: "countryMasterDegree",
      label: "Country",
      requiredErrorMsg: "Country is required"
    },
    dateOfMasterDegreeGraduation: {
      name: "dateOfMasterDegreeGraduation",
      label: "Date of Master’s Degree Graduation",
      requiredErrorMsg: "Date is required"
    },

    doctoralDegreeBackground: {
      name: "doctoralDegreeBackground",
      label: "Doctoral Degree Background",
      requiredErrorMsg: "Doctoral Degree Background is required"
    },
    graduatedUniversityInstituteDoctoral: {
      name: "graduatedUniversityInstituteDoctoral",
      label: "Graduated from University/Institute",
      requiredErrorMsg: "Graduated is required"
    },
    countryDoctoral: {
      name: "countryDoctoral",
      label: "Country",
      requiredErrorMsg: "Country is required"
    },
    dateGraduationDoctoral: {
      name: "dateGraduationDoctoral",
      label: "Date of Doctoral Degree Graduation ",
      requiredErrorMsg: "Date is required"
    },

    // Page 4
    workingExperienceList: {
      name: "workingExperienceList",
      subMenu: [
        {
          position: {
            name: "position",
            label: "Position",
            requiredErrorMsg: "Position is required"
          },
          companyOrganization: {
            name: "companyOrganization",
            label: "Company / Organization",
            requiredErrorMsg: "Company / Organization is required"
          },
          country: {
            name: "country",
            label: "Country",
            requiredErrorMsg: "Country is required"
          },
          started: {
            name: "started",
            label: "Started",
            requiredErrorMsg: "Started is required"
          },
          ended: {
            name: "ended",
            label: "Ended",
            requiredErrorMsg: "Ended is required"
          },
          stillInRole: {
            name: "stillInRole",
            label: "Still in role"
          }
        }
      ]
    },
    publication: {
      name: "publication",
      label: "Publication",
      requiredErrorMsg: "Publication is required"
    },
    awards: {
      name: "awards",
      label: "Awards",
      requiredErrorMsg: "Awards is required"
    },
    cvOrResume: {
      name: "cvOrResume",
      label: "CV or Resume",
      requiredErrorMsg: "CV or Resume is required",
      file: {}
    }
  }
};
